import { translate } from '../../common/helpers/translate.helper';

interface ChartTitleTranslations {
    completedOrders: string;
    pricePerUnit: string;
    volume: string;
    total: string;
}

export const useChartTitleTranslations = (): ChartTitleTranslations => {
    return {
        completedOrders: translate('reporting.completed'),
        pricePerUnit: translate('reporting.ppl'),
        volume: translate('reporting.volume'),
        total: translate('reporting.total'),
    };
};
